export default "__VITE_ASSET__BI4ZMH0x__"